import { render } from "./PlayerInputFactory.vue?vue&type=template&id=bf371f06&ts=true"
import script from "./PlayerInputFactory.vue?vue&type=script&lang=ts"
export * from "./PlayerInputFactory.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__